import { Alert } from '@verbit-ai/verbit-ui-library'

import { useEditor } from 'src/contexts/EditorContext'

import * as S from './styles'

const MESSAGE = 'Transcript editing is locked'

export const EditingLockedBanner = () => {
    const { isEditingLocked } = useEditor()

    if (!isEditingLocked) {
        return null
    }

    return (
        <S.CenteredAlertContainer>
            <Alert text={MESSAGE} status="info" />
        </S.CenteredAlertContainer>
    )
}
